export const ROUTES = [
  {
    label: 'new_registration',
    link: '',
  },
  {
    label: 'view_list_of_devices',
    link: 'my-devices',
  },
];
